import { Injectable } from '@angular/core';
import { User } from '../models/simskillsModels';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private firebaseService: FirebaseService) {}

  public getUsers() {
    return this.firebaseService.getDocument('/users/');
  }

  public getUser(userId: string) {
    return this.firebaseService.getDocument('/users/' + userId);
  }
  
  public getUserRole(userId: string) {
    return this.firebaseService.getDocument(`/users/${userId}/role`);
  }

  public async addUser(user: User) {
    return await this.firebaseService.addDocument('/users/', user);
  }

  public async removeUser(userId: string) {
    return await this.firebaseService.deleteDocument('/users', userId);
  }

  public async editUser(userId: string, updatedData: Partial<User>) {
    return await this.firebaseService.updateDocument(
      '/users',
      userId,
      updatedData
    );
  }
}
